import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Day2 from '../Day2/Day2';
import Debattale from '../Debattale';
import Vaad from '../Vaad';
import Nrityarupakam from '../Nrityarupakam';
import StreetPlay from '../StreetPlay';
import ChromaQuest from '../ChromaQuest';
import Sci from '../Sci';
import Fusion from '../Fusion';
import CodeClash from '../CodeClash';
import VeritasInterna from '../VeritasInterna';
import NpsyprMUN from '../NpsyprMUN';
import Commerce from '../Commerce';
import GenusVincere from '../GenusVincere';
import Art from '../Art';
import Throne from '../Throne';
import DezainovateDay2 from '../DezainovateDay2';
import Veledicition from '../Veledicition';
import FlashMob from '../FlashMob';

const FaqGroupItem = ({ tittle, items }) => {
  const theme = useTheme();
  return (
    
      <Box id='Day2'>
        
        <br></br>
        <br></br>
        <Typography variant='h6' align='center' fontWeight={700} >
        DAY 2
        </Typography>

        <Box marginBottom={2} marginLeft={3} marginRight={3}>
          <br></br>

          <Day2/>
        </Box>

        <Box>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}  align='left'>Debattle</Typography>
              <Typography  align='right'>- Verbal Combat Zone</Typography>

            </Box>
            <AccordionDetails>
            Where sharp minds clash, arguments unfold, and words become weapons of persuasion.
            </AccordionDetails>

            <Debattale/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
            {/* <a href="#Day2" align='right'>Back to DAY 2</a> */}
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}  align='left'>Vaad-Vivaad</Typography>
              <Typography  align='right'> - Voices in Verse & Verdict</Typography>

            </Box>
            <AccordionDetails>
            Debating contemporary issues with eloquence, conviction and respect.
            </AccordionDetails>

            <Vaad/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left'>Nrityarupakam</Typography>
              <Typography align='right'> - Divine Dance Drama</Typography>

            </Box>
            <AccordionDetails>
            An artistic blend of dance, drama and devotion portraying the avatars of Lord Vishnu.

            </AccordionDetails>

            <Nrityarupakam/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left'>Street Play </Typography>
              {/* <Typography align='right'> - Ad-Venture: Creativity Unleashed!</Typography> */}

            </Box>
            {/* <AccordionDetails>
            This competition challenged participants to craft humorous advertisements for fictional products, allowing them to exhibit their creativity and artistic flair.
            </AccordionDetails> */}

            <StreetPlay/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left'>Chroma Quest</Typography>
              <Typography align='right'>- Geo-Design Challenge</Typography>

            </Box>
            <AccordionDetails>
            Exploring geometry through design challenges and games.
            </AccordionDetails>

            <ChromaQuest/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000} align='left'>SCI-FI SYNC </Typography>
              <Typography align='right'>- Draw, Jam, Imagine</Typography>

            </Box>
            <AccordionDetails>
            Bringing futuristic stories to life with art and improvisation.
            </AccordionDetails>

            <Sci/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>

          <br></br>

          <Box
            align={'justify'}
            component={Accordion}
            padding={1}
            borderRadius={`${theme.spacing(1)} !important`}
            sx={{
              '&::before': {
                display: 'none',
              },
            }}
          >
            <Box
              component={AccordionSummary}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
            >
              <Typography fontWeight={1000}>Fusion Frontiers</Typography>
              <Typography align='right'>- Science Meets Structure</Typography>

            </Box>
            <AccordionDetails>
            Exploring science through the lens of iconic architecture.
            </AccordionDetails>

            <Fusion/>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
            </Box>
          </Box>
          <br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}  align='left'>Code Clash</Typography>
    <Typography  align='right'> - Algorithm Arena</Typography>

  </Box>
  <AccordionDetails>
  A race against time to solve programming puzzles with precision.
  </AccordionDetails>

  <CodeClash/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left'>Veritas Interna</Typography>
    <Typography align='right'> - Crisis Decoded</Typography>

  </Box>
  <AccordionDetails>
  Analysing crises through the lens of psychology and strategy.

  </AccordionDetails>

  <VeritasInterna/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left'>NPSYPR MUN</Typography>
    <Typography align='right'> - Diplomats of Tomorrow</Typography>

  </Box>
  <AccordionDetails>
  Students become diplomats, debating and negotiating global issues.
  </AccordionDetails>

  <NpsyprMUN/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left'>Commerce Maestro</Typography>
    <Typography align='right'>- Boardroom Battles</Typography>

  </Box>
  <AccordionDetails>
  Future business leaders navigating complex corporate challenges.
  </AccordionDetails>

  <Commerce/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000} align='left'>Genus Vincere </Typography>
    <Typography align='right'>- F1 Strategy Drive</Typography>

  </Box>
  <AccordionDetails>
  F1-themed simulations where teams race through strategy and negotiation.
  </AccordionDetails>

  <GenusVincere/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>

<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}>Art Relay</Typography>
    <Typography align='right'>- Brush, Beat & Beyond</Typography>

  </Box>
  <AccordionDetails>
  Collaborative art, one brushstroke at a time.
  </AccordionDetails>

  <Art/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>
<br></br>

<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}>Rhythmscape</Typography>
    <Typography align='right'>- Battle of the Bands</Typography>

  </Box>
  <AccordionDetails>
  Bands battle it out, blending melody, rhythm and stagecraft.
  </AccordionDetails>

  <Throne/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>
<br></br>
<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}>Dezainovate</Typography>
    <Typography align='right'>- Concepts to Catwalk</Typography>

  </Box>
  <AccordionDetails>
  From imaginative product design to creative problem-solving, culminating in a striking runway showcase of contrasting aesthetics.
  </AccordionDetails>

  <DezainovateDay2/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>
<br></br>
<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}>Valediction</Typography>
    {/* <Typography align='right'>- Battle of the Bands</Typography> */}

  </Box>

  <Veledicition/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>
<br></br>
<Box
  align={'justify'}
  component={Accordion}
  padding={1}
  borderRadius={`${theme.spacing(1)} !important`}
  sx={{
    '&::before': {
      display: 'none',
    },
  }}
>
  <Box
    component={AccordionSummary}
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
  >
    <Typography fontWeight={1000}>Flash Mob</Typography>
    {/* <Typography align='right'>- Battle of the Bands</Typography> */}

  </Box>
  {/* <AccordionDetails>
  An inter-school rock band competition where bands competed to claim the throne through their performance.
  </AccordionDetails> */}

  <FlashMob/>
  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
  <a href="#Day2" sx={{ ml: 'auto' }}>Back to DAY 2</a>
  </Box>
</Box>
<br></br>
        </Box>
      </Box>
      
      
  
  );
};

FaqGroupItem.propTypes = {
  tittle: PropTypes.string,
  items: PropTypes.array.isRequired,
};

const Day2Goonj2025 = () => {
  return (
    <Box>
      <Box marginBottom={1}>
        <FaqGroupItem
          items={[
            
          ]}
        />
      </Box>
    </Box>
  );
};

export default Day2Goonj2025;